import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SignedNumberPipe } from './signed-number.pipe';

@Component({
  standalone: true,
  selector: 'accredible-members-count',
  templateUrl: `./members-count.component.html`,
  styleUrls: ['./members-count.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, AccredibleIconComponentModule, SignedNumberPipe],
})
export class MembersCountComponent {
  membersCount = input<number>();
}
